<template>
  <div>
    <b-row v-if="show" class="no-gutters">
      <b-col class="d-flex justify-content-end shadow p-3">
        <b-button variant="primary" @click="refreshSnapshots">
          <font-awesome-icon icon="sync-alt" />
          {{ $t('refresh') | capitalize }}
        </b-button>
        <b-button variant="primary" class="ml-3" @click.prevent="toggleEditMode">
          <template v-if="project.isEditModeEnabled">
            <font-awesome-icon icon="check-circle" />
            {{ $t('done') | capitalize }}
          </template>
          <template v-else>
            <font-awesome-icon icon="pen" />
            {{ $t('edit') | capitalize }}
          </template>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import eventBus from '@/components/utils/slideout-panel/eventBus';
import BaseContextMenuMixin from '@/components/context-menus/BaseContextMenu';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'ChangeProject',
  mixins: [
    BaseContextMenuMixin,
  ],
  computed: {
    ...mapState('app', [
      'project',
    ]),
  },
  methods: {
    ...mapActions('app', [
      'setState',
    ]),
    toggleEditMode() {
      const isEditModeEnabled = !this.project.isEditModeEnabled;
      this.setState({ section: 'project', setting: { isEditModeEnabled } });
    },
    refreshSnapshots() {
      eventBus.$emit('refreshSnapshots');
    },
  },
  destroyed() {
    this.setState({ section: 'project', setting: { isEditModeEnabled: false } });
  },
};
</script>

<style scoped>

</style>
